import { Component, OnInit } from '@angular/core';

import { VideoService } from '../../service/video.service';
import { Video } from './../../models/video';
import {Router} from '@angular/router';

@Component({
  selector: 'app-video',
  templateUrl: './video.component.html',
  styleUrls: ['./video.component.css']
})
export class VideoComponent implements OnInit {
  videos: Array<Video> = new Array<Video>();

  constructor(private videoservice: VideoService, private Ruta: Router) { }

  ngOnInit(): void {
    this.videoservice.getVid().subscribe(resp => {
      for (const data of resp.body) {
        this.videos.push(data);
      }
    });
  }

  irDetalleVid(video: Video) {
    this.videoservice.video = video;
    this.Ruta.navigateByUrl('detail-video/' + this.videoservice.video.tituloProyectoVideo);
  }
}
